import {matchPath} from 'react-router';

import type {PageConfig} from '#queries/react_pages/index.js';

export function extractPathname(href: string): string {
  try {
    return new URL(href, window.location.origin).pathname;
  } catch {
    return href.split('?')[0].split('#')[0];
  }
}

export function findRegistryMatch(
  reactPages: PageConfig[] | undefined,
  pathname: string
): PageConfig | void {
  if (!reactPages) return;

  return reactPages.find(page => {
    try {
      return !!matchPath({path: page.path, end: false}, pathname);
    } catch {
      return false;
    }
  });
}
